import { NbDialogService } from '@nebular/theme';
import { mongoId } from '../../@core/common/global';
import { ApiService } from '../../@core/service/api.service';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { SharedDataService } from '../../@core/service/shared-data.service';
import { BusinessModel } from '../../@models';
import { AbstractItem, AbstractItemType } from './abstractItem';

export abstract class AbstractProduct<T extends AbstractItemType> extends AbstractItem<T> {

  public locked: boolean = false;
  protected dirtyString = '';
  // protected businesses: BusinessModel[];
  // public businessOptions: { id: string, name: string }[] = [];

  public sort: { column: string, dir: number } = { column: null, dir: -1 };

  constructor(
    protected dialogService: NbDialogService,
    public api: ApiService,
    public auth: AuthGuardService,
    public data: SharedDataService,
  ) {
    super(dialogService, api, auth, data);
  }

  getVersionString(item: T): string {
    const v = Number(item.version || 1);
    const vs = (v-1).toString().padStart(2, '0');
    return `VS${vs}${item.draft ? '-DRAFT' : ''}`;
  }

  removeVersionString(str: string): string {
    return str.replace(/ *\((\d+-)?VS\d+\)/, '');
  }

  filterItem(field, key, search) {
    const val = field && field[key] && field[key].toString();
    return val && val.toLowerCase().includes(search)
  }

  sortItem(a, b, key) {
    const vala = a && a[key] && a[key].toString().toLowerCase();
    const valb = b && b[key] && b[key].toString().toLowerCase();
    return vala > valb ? this.sort.dir: -this.sort.dir;
  }

  createNewVersion() {
    const newVersion = super.getMaxVersion(this.selected) + 1;
    const newItem = JSON.parse(JSON.stringify(this.selected));
    newItem._id = null;
    newItem.draft = true;
    newItem.version = newVersion;
    newVersion === 1 ? newItem.changelog = 'INI' : '';
    this.selected = newItem;
    this.loadChangelog(this.selected);
    // this.items.push(newItem);
    this.dirtyString = JSON.stringify(this.selected);
  }

  isDirty() {
    return false; // TODO: dirty check update
    if (!this.dirtyString) return;
    const itemCopy = JSON.parse(JSON.stringify(this.selected));
    const dirtyCopy = JSON.parse(this.dirtyString);
    // ignore content, calcName, calcCode
    ['_id', 'editCount', 'draft', 'content', 'calcName', 'calcCode', 'changelog', 'createdAt', 'updatedAt', '__v', 'owner'].forEach(el => itemCopy[el] = dirtyCopy[el] = undefined);
    const item = JSON.stringify(itemCopy);
    const dirty = JSON.stringify(dirtyCopy);
    for (const i in itemCopy) {
      // console.log('dirty: ', JSON.stringify(mongoId(dirtyCopy[i])) !== JSON.stringify(mongoId(itemCopy[i])), i, JSON.stringify(mongoId(dirtyCopy[i])), JSON.stringify(mongoId(itemCopy[i])))
    }
    return item !== dirty;
  }

  onSort(col) {
    if (col === this.sort.column) {
      this.sort.dir = -this.sort.dir;
    } else {
      this.sort.column = col;
    }
  }

  getItems(items: any[] = null): any[] {
    return super.getItems(items);
  }

  getCurrentItems(items: any[] = null, withDrafts: boolean = false): any[] {
    return super.getCurrentItems(items, withDrafts);
  }

  getVersions(item: T): T[] {
    return super.getVersions(item)
  }

  isFirstVersion() {
    return super.isFirstVersion();
  }

  lock(doLock: boolean = true) {
    super.lock(doLock);
  }

  create() {
    super.create();
  }

  async cancelDraft(item: T) {
    return super.cancelDraft(item);
  }

  async save(item: T, draft: boolean = false): Promise<T> {
    return super.save(item, draft);
  }

  async reload(item: T): Promise<T> {
    return super.reload(item);
  }

  async toggleSidebar(item: T) {
    super.toggleSidebar(item);
  }

  canDismiss(item: T): Promise<boolean> {
    return super.canDismiss(item);
  }


}
